import * as _ from 'underscore';

export class DataList<Tlist,Tdetail = {}> {
   selected:Tdetail;
   list:Tlist[];
   total:number;
   checkedIds:number[] = [];

   get checkedCount():number {
      return this.checkedIds.length;
   }

   get isAllChecked():boolean {
      if (this.list && this.list.length > 0) {
         let pageIds = _.pluck(this.list, 'id');
         return _.union(pageIds, this.checkedIds).length == this.checkedIds.length;
      }

      return false;
   }

   isChecked(row):boolean {
      return _.contains(this.checkedIds, row.id);
   }

   toggle($event:MouseEvent, row) {
      $event.stopPropagation();
      if (_.contains(this.checkedIds, row.id)) {
         this.checkedIds = _.without(this.checkedIds, row.id);
      } else {
         this.checkedIds.push(row.id);
      }
   }

   toggleAll() {
      let pageIds = _.pluck(this.list, 'id');
      if (!this.isAllChecked) {
         this.checkedIds = _.union(pageIds, this.checkedIds);
      } else {
         this.checkedIds = _.without(this.checkedIds, ...pageIds);
      }
   }

   setList(data:Tlist[], total:number) {
      this.list = data;
      this.total = total;
      this.selected = null;
   }
}
